export default "__VITE_ASSET__SjD49Xg3__"